module.exports = __webpack_public_path__ + "static/img/hz-02.b13138a9.jpg";